import { createSelector } from '@ngrx/store'
import { authFeature } from './auth.state'

export const {
  selectAccessToken, // Auto-selects `accessToken`
  selectUser, // Auto-selects `user`
  selectIsAuthenticated, // Auto-selects `isAuthenticated`
  selectError // Auto-selects `error`
} = authFeature

// export const selectUserPermissions = createSelector(selectUser, user => {
//   return user?.userRole?.permissions ?? {}
// })

// export const selectUserPermissions = createSelector(selectUser, user => {
//   const rolePermissions = user?.userRole?.permissions ?? {}
//   const permissionSets = user?.permissionSets ?? []
//   // console.log('permissions sets', user)
//   const permissionMap: Record<string, Set<string>> = {}

//   const mergePermissions = (source: unknown) => {
//     if (source && typeof source === 'object') {
//       const perms = source as Record<string, string[]>
//       for (const [module, actions] of Object.entries(perms)) {
//         if (!permissionMap[module]) {
//           permissionMap[module] = new Set()
//         }
//         actions.forEach(action => permissionMap[module].add(action))
//       }
//     }
//   }

//   mergePermissions(rolePermissions)

//   for (const set of permissionSets) {
//     mergePermissions(set?.userRole?.permissions)
//   }

//   const finalPermissions: Record<string, string[]> = {}
//   for (const [module, actionsSet] of Object.entries(permissionMap)) {
//     finalPermissions[module] = Array.from(actionsSet)
//   }
//   // console.log('permissions', finalPermissions)
//   return finalPermissions
// })

//27 aug 2025 new role
// export const selectUserPermissions = createSelector(selectUser, user => {
//   // 👇 force array
//   const permissions = Array.isArray(user?.role?.permissions) ? user.role.permissions : []
//   const userBusinessId = user?.businessId
//   const userOfficeId = user?.officeId
//   const permissionMap: Record<string, Set<string>> = {}
//   for (const perm of permissions) {
//     const moduleName = perm.module?.name ?? 'unknown'

//     // ✅ Scope check
//     if (perm.scopeType === 'business' && perm.businessId !== userBusinessId) {
//       continue
//     }
//     if (perm.scopeType === 'office' && perm.officeId !== userOfficeId) {
//       continue
//     }
//     // global → no check needed

//     if (!permissionMap[moduleName]) {
//       permissionMap[moduleName] = new Set()
//     }
//     permissionMap[moduleName].add(perm.action)
//   }

//   // Flatten Set -> Array
//   const finalPermissions: Record<string, string[]> = {}
//   for (const [module, actions] of Object.entries(permissionMap)) {
//     finalPermissions[module] = Array.from(actions)
//   }
//   console.log('final permissions', finalPermissions)
//   return finalPermissions
// })

//only userroles 23 march 2026
// export const selectUserPermissions = createSelector(selectUser, user => {
//   const permissionMap: Record<string, Set<string>> = {}

//   const userBusinessId = user?.businessId
//   const userOfficeId = user?.officeId
//   // Loop through each userRole
//   user?.userRoles?.forEach(userRole => {
//     const role = userRole.role
//     if (!role) return

//     // Apply scope check at the userRole level
//     if (role.scopeType === 'business' && userRole.businessId !== userBusinessId) return
//     if (role.scopeType === 'office' && userRole.officeId !== userOfficeId) return
//     // global → include all

//     // Collect permissions from rolePermissions
//     role.rolePermissions?.forEach(rp => {
//       const perm = rp.permission
//       if (!perm) return

//       const moduleName = perm.module?.name ?? 'unknown'

//       if (!permissionMap[moduleName]) {
//         permissionMap[moduleName] = new Set()
//       }
//       permissionMap[moduleName].add(perm.action)
//     })
//   })

//   // Flatten Set -> Array
//   const finalPermissions: Record<string, string[]> = {}
//   for (const [module, actions] of Object.entries(permissionMap)) {
//     finalPermissions[module] = Array.from(actions)
//   }

//   return finalPermissions
// })

//userroles with userpermissionsets 23 march 2026
export const selectUserPermissions = createSelector(selectUser, user => {
  const permissionMap: Record<string, Set<string>> = {}

  const userBusinessId = user?.businessId
  const userOfficeId = user?.officeId

  // ✅ 1. ROLE PERMISSIONS
  user?.userRoles?.forEach(userRole => {
    const role = userRole.role
    if (!role) return

    if (role.scopeType === 'business' && userRole.businessId !== userBusinessId) return
    if (role.scopeType === 'office' && userRole.officeId !== userOfficeId) return

    role.rolePermissions?.forEach(rp => {
      const perm = rp.permission
      if (!perm) return

      const moduleName = perm.module?.name ?? 'unknown'

      if (!permissionMap[moduleName]) {
        permissionMap[moduleName] = new Set()
      }

      permissionMap[moduleName].add(perm.action)
    })
  })

  // ✅ 2. PERMISSION SETS (NEW 🔥)
  user?.userPermissionSets?.forEach(ups => {
    const ps = ups.permissionSet
    if (!ps) return

    // ⏳ validity check
    if (ups.validUpto && new Date(ups.validUpto) < new Date()) return

    ps.permissionSetPermissions?.forEach(psp => {
      const perm = psp.permission
      if (!perm) return

      const moduleName = perm.module?.name ?? 'unknown'

      if (!permissionMap[moduleName]) {
        permissionMap[moduleName] = new Set()
      }

      permissionMap[moduleName].add(perm.action)
    })
  })

  // ✅ 3. DIRECT PERMISSIONS (if needed)
  // user?.directPermissions?.forEach(dp => {
  //   const perm = dp.permission
  //   if (!perm) return

  //   const moduleName = perm.module?.name ?? 'unknown'

  //   if (!permissionMap[moduleName]) {
  //     permissionMap[moduleName] = new Set()
  //   }

  //   permissionMap[moduleName].add(perm.action)
  // })

  // ✅ Flatten
  const finalPermissions: Record<string, string[]> = {}

  for (const [module, actions] of Object.entries(permissionMap)) {
    finalPermissions[module] = Array.from(actions)
  }

  return finalPermissions
})
